export enum OperationMode {
  Fan = 0,
  Heating = 1,
  Cooling = 2,
  Automatic = 3,
  Dry = 5,
  Dependent = 6,
}
